import { UrlMatchResult, UrlSegment } from '@angular/router';

export const AI_ANALYST_SEGMENT = 'ai-analyst';
export const AI_ANALYST_ADMIN_SEGMENT = 'ai-analyst-admin';

/**
 * Matches both `/ai-analyst` and `/ai-analyst/{chatId}` from ONE route entry, exposing the chat id
 * as a `chatId` param exactly as a `:chatId` path would.
 *
 * Declaring those two urls as two route entries pointing at the same component is what this replaces,
 * and it is not a style preference: Angular reuses a component only when the params change WITHIN one
 * route config, so two entries make the component get destroyed and rebuilt the moment a newly created
 * chat's id is appended to the url. Every unpersisted turn flag dies with it, which on the first turn
 * of a new chat silently drops the stopped marker and both turn caveats.
 *
 * Returns null for anything longer than two segments, and for sibling paths that merely start with the
 * same text (`ai-analyst-admin` is a different first segment, not a prefix match).
 */
export function aiAnalystRouteMatcher(segments: UrlSegment[]): UrlMatchResult | null {
    if (segments.length === 0 || segments.length > 2 || segments[0].path !== AI_ANALYST_SEGMENT) {
        return null;
    }

    if (segments.length === 1) {
        return { consumed: segments };
    }

    return { consumed: segments, posParams: { chatId: segments[1] } };
}

export const AI_ANALYST_ROUTE = `/dashboard/${AI_ANALYST_SEGMENT}`;
